import DialogView from '../../dialog/Dialog.view';
import type MarketPropertiesDialogProperties from '../MarketPropertiesDialog.properties.ts';
import styles from './MarketPropertiesDialog.desktop.module.css';
import InputView from '../../../components/input/Input.view.tsx';
import { useTranslation } from 'react-i18next';
import { useMarketPropertiesDialogController } from '../MarketPropertiesDialog.controller.ts';
import ToggleButtonView from '../../../components/toggle-button/ToggleButton.view.tsx';
import FileInputView from '../../../components/file-input/FileInput.view.tsx';
import CanUploadFile from '../../../security/CanUploadFile.ts';

export default function MarketPropertiesDialogDesktopView(props: MarketPropertiesDialogProperties) {
  const { t } = useTranslation();
  const {
    name,
    street,
    houseNumber,
    zip,
    city,
    district,
    areaX,
    areaY,
    enableMarketDrawing,
    filename,
    setName,
    setStreet,
    setHouseNumber,
    handleZipChange,
    setCity,
    setDistrict,
    handleAreaXChange,
    handleAreaYChange,
    handleToggleClicked,
    handleSaveClick,
    handleUploadClick,
  } = useMarketPropertiesDialogController();

  return (
    <DialogView header={name} onBackdrop={props.handleDialogCloseClick}>
      <>
        <table className={styles.table}>
          <tbody>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketNameLabel')}</td>
              <td className={styles.tdValue}>
                <InputView value={name} onChange={(e) => setName(e.target.value)} />
              </td>
            </tr>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketStreetLabel')}</td>
              <td className={styles.tdValue}>
                <InputView value={street} onChange={(e) => setStreet(e.target.value)} />
              </td>
            </tr>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketHouseNumberLabel')}</td>
              <td className={styles.tdValue}>
                <InputView value={houseNumber} onChange={(e) => setHouseNumber(e.target.value)} />
              </td>
            </tr>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketZipLabel')}</td>
              <td className={styles.tdValue}>
                <InputView
                  value={zip}
                  type="number"
                  min="10000"
                  max="99999"
                  onChange={(e) => handleZipChange(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketCityLabel')}</td>
              <td className={styles.tdValue}>
                <InputView value={city} onChange={(e) => setCity(e.target.value)} />
              </td>
            </tr>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketDistrictLabel')}</td>
              <td className={styles.tdValue}>
                <InputView value={district} onChange={(e) => setDistrict(e.target.value)} />
              </td>
            </tr>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketAreaXLabel')}</td>
              <td className={styles.tdValue}>
                <InputView
                  value={areaX}
                  type="number"
                  min="1"
                  max="9999"
                  onChange={(e) => handleAreaXChange(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketAreaYLabel')}</td>
              <td className={styles.tdValue}>
                <InputView
                  value={areaY}
                  type="number"
                  min="1"
                  max="9999"
                  onChange={(e) => handleAreaYChange(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className={styles.tdKey}>{t('ui.marketEnableMarketDrawing')}</td>
              <td className={styles.tdValue}>
                <ToggleButtonView
                  defaultOn={enableMarketDrawing}
                  onToggle={handleToggleClicked}
                  onLabel={t('ui.marketEnableMarketDrawingToggleEnable')}
                  offLabel={t('ui.marketEnableMarketDrawingToggleDisable')}
                />
              </td>
            </tr>
            {CanUploadFile() && (
              <tr>
                <td className={styles.tdKey}>{filename}</td>
                <td className={styles.tdValue}>
                  <FileInputView
                    onChange={(e) => handleUploadClick(e.target.files)}
                    width={160}
                    label={t('ui.upload')}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className={styles.buttonContainer}>
          <button className={styles.buttonSave} onClick={handleSaveClick}>
            {t('ui.save')}
          </button>
        </div>
      </>
    </DialogView>
  );
}
